import React, { useState } from 'react';
import imagenHome from '../../images/hombre_home_cut.png';
import logoNav from '../../images/UNIQ_azul.png';

export const Banner = () => {
	return (

		<div className="hero">
			<div className="nav">
                <img src={logoNav} alt="Uniq logo white" />
			</div>
			<div className="portada">
				<div className="informacion">
					<div className="texto">
						<h2>
							<span>Cashback</span> en comercios seleccionados
						</h2>
						<p>
							Ahora puedes recibir cashback por todas tus compras realizadas con tu tarjeta de crédito en nuestros comercios afiliados.
						</p>
						<button className="button" 	onClick={() => window.open("/conoceMas", "_blank")}>
						Conoce más aquí
						</button>
					</div>
				</div>
			</div>
		</div>

		
	);
	
};

